import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
    DEFAULT_PAGE_SIZE,
    LOCAL_STORAGE_ALL_CANDIDATE_IDS,
    LOCAL_STORAGE_USER_LOGIN_INFO,
    MAX_PAGE_LINK_DISPLAY,
    ORDER_BY,
    ODER_BY_TYPE,
    ResponseCode
} from '@app/constants/Common';
import CreateCandidateGroupModal from "@pages/savedlist/CreateCandidateGroupModal";
import { arrayToString, capitalizeName, stringToArray } from "@app/utils/CommonUtils";
import AddCandidateIntoGroupModal from "@pages/savedlist/AddCandidateIntoGroupModal";
import { requestCandidateGroups } from "@app/services/CandidateGroupService";
import RefereeConfirmModal from "@pages/candidate/commonview/RefereeConfirmModal";
import ShowHideCandidatesModal from "@pages/candidate/commonview/ShowHideCandidatesModal";
import RunJobMainModal from "@pages/job/runjob/RunJobMainModal";
import { alertMessage, showMessage } from "@app/constants/Messages";
import DraftPreviewModal from "@pages/job/runjob/DraftPreviewModal";
import { SendEmailInviteJobTabIds } from "@pages/job/runjob/RunJobParentTabContent";
import SelectJobModal from "@pages/candidate/list/SelectJobModal";
import { ProcessJobInternalProcess } from "@pages/jobpipeline/common/Constant";
import DVTJCUVCandidateActions from "@pages/candidate/list/DVTJCUVCandidateActions";
import DVTJCUVEmailInviteModal, { EmailInviteMode } from "@pages/candidate/list/DVTJCUVEmailInviteModal";
import { requestStartRunDVTJCUV } from "@pages/dvtjcuv/service/DVTJCUVService";
import { DVTJCUVCddOpenAndNotSddvParentTabs } from "@pages/dvtjcuv/common/CddOpenAndNotSddvTabs";
// import DVTJCUVSearchCddJobModal
import DVTJCUVSearchCddJobModal from '@pages/dvtjcuv/rundvtjcuv/search/searchcddjob/DVTJCUVSearchCddJobModal';
import {
    DVTJCUVAcquireCddEmailFUTabIds,
    DVTJCUVAcquireCddParentTabIds,
    DVTJCUVAcquireCddSendEmailTabIds
} from "@pages/dvtjcuv/common/AcquireCddTabs";
import DVTJCUVEmailInviteTempInfoModal from "@pages/candidate/detail/DVTJCUVEmailInviteTempInfoModal";
import {
    DVTJCUVSearchCddJobParentTabs,
    DVTJCUVSearchCddJobSendEmailBriefUVTabs
} from "@pages/dvtjcuv/common/SearchCddJobTabs";
import {
    DVTJCUVConnectCddEmpParentTabs,
    DVTJCUVConnectCddSendEmailReceiverUpdateInfoTabs,
    DVTJCUVConnectCddSendEmailTabs
} from "@pages/dvtjcuv/common/ConnectCddEmpTabs";
import InputCddGPEmpDiscussionModal from "@pages/dvtjcuv/rundvtjcuv/connectcddemp/InputCddGPEmpDiscussionModal";
import ConnectCddEmpReceiverNeedFuSortComponent, { ConnectCddEmpReceiverNeedFuSortOptions } from '@pages/candidate/common/ConnectCddEmpReceiverNeedFuSort';
import { DVTJCUVWorkWithRecParentTabs, DVTJCUVWorkWithRecSendEmailInviteJobTabs } from '@pages/dvtjcuv/common/WorkWithRecTabs';

export const CandidateListMode = {
    CANDIDATE_LIST: 1,
    EMAIL_INVITE_JOB: 2,
    DVTJCUV: 3,
    DVTJCUV_SEARCH_CDD_JOB_BRIEF_EMAIL: 4,
    DVTJCUV_SEARCH_CDD_JOB_EXCLUDE_RECEIVERS: 5,
    DVTJCUV_SEARCH_CDD_JOB_EXCLUDE_EMPLOYERS: 6,
    DVTJCUV_SEARCH_CDD_JOB_CHOOSE_RECEIVERS: 7,
    DVTJCUV_SEARCH_CDD_JOB_RECEIVER_AUTO_RELEASE: 8,
    DVTJCUV_SEARCH_CDD_JOB_RECEIVER_SENT: 9,
    DVTJCUV_SEARCH_CDD_JOB_SOURCE_MORE_RECEIVER: 10,
    DVTJCUV_SEARCH_CDD_JOB_RECEIVER_MANUALLY_RELEASE: 11,
    DVTJCUV_SEARCH_CDD: 12,
}


const CandidateListTable = (props) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [numberPages, setNumberPages] = useState(0);
    const [displayPages, setDisplayPages] = useState([]);
    const [selectCandidateId, setSelectCandidateId] = useState('');
    const [isShowSearchCddJobModal, setIsShowSearchCddJobModal] = useState(false);
    const [searchOrderBy, setSearchOrderBy] = useState(ORDER_BY.DESC_UPDATE_DATE);
    const [showCreateGroupModal, setShowCreateGroupModal] = useState(false);
    const [showShowHideCandidatesModal, setShowShowHideCandidatesModal] = useState(false);
    const [showAddCandidateIntoGroupModal, setShowAddCandidateIntoGroupModal] = useState(false);
    const [showRefereeConfirmModal, setShowRefereeConfirmModal] = useState(false);
    const [showRunJobModal, setShowRunJobModal] = useState(false);
    const [showDVTJCUVEmailInviteModal, setShowDVTJCUVEmailInviteModal] = useState(false);
    const [showSelectJobModal, setShowSelectJobModal] = useState(false);
    const [showDraftInviteMailModal, setShowDraftMailModal] = useState(false);
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [candidateGroups, setCandidateGroups] = useState([]);
    const [selectedCandidateIds, setSelectedCandidateIds] = useState([]);
    const [sendingEmailCandidateIds, setSendingEmailCandidateIds] = useState([]);
    const [candidateList, setCandidateList] = useState([]);
    const [isSelectedAll, setSelectedAll] = useState(false);
    const [isEmbeddedIntoJob, setEmbeddedIntoJob] = useState(false);
    const [isInviteSendJobMode, setInviteSendJobMode] = useState(false);
    const [selectedCount, setSelectedCount] = useState(0);
    const [showDVTJCUVEmailInviteTempModal, setShowDVTJCUVEmailInviteTempModal] = useState(false);
    const [showInputCddGPEmpDiscussionModal, setShowInputCddGPEmpDiscussionModal] = useState(false);
    const [sortColumnInfo, setSortColumnInfo] = useState({});
    const {
        // Trường hợp hiển thị ds receivers từ search job cdd có id là cddId.
        cddId,
        candidates,
        allCandidateIds,
        totalCount,
        showBtnSelect,
        hideBtnActions,
        mode,
        noPagination,
        mailInviteJobTab,
        parentTab, subTab,
        onSendBriefEmailDVTJCUV,
        onSearchCandidates,
        onReMailInviteJob,
        onDelete,
        onExportExcel,
        onEmailFU,
        onSendEmailInviteJob,
        onEmbeddedIntoJob,
        saveInputJobPipeline,
        onDraftPreview,
        onSaveChosenReceivers,
        onReturnSelectedItems,
        onInputEmailInputDVTJCUV,
        onRemoveSendMailThisTime,
        onDeleteReceiverManuallyRelease,
        removeCandidateOutTabs,
        moveCandidatesToTab,
        updateCandidatesInSendMails,
        isExporting,
        canDelete
    } = props

    const createSelectedCandidateIds = (isAllCanIds = false) => {
        console.log('createSelectedCandidateIds isAllCanIds', isAllCanIds)
        if (isAllCanIds) {
            setSelectedCandidateIds([...allCandidateIds])
            return allCandidateIds
        }
        // let canIds = []
        // 20251129: Update to select candidates between multiple pages
        let selectCanIds = selectedCandidateIds.length > 0 ? [...selectedCandidateIds] : []
        candidateList.forEach(item => {
            const canId = item.general.id
            // 1. Nếu item.isSelected = true và canId chưa có trong selectCanIds thì thêm vào
            // 2. Nếu item.isSelected = false và canId đã có trong selectCanIds thì xóa đi
            if (item.isSelected) {
                if (!selectCanIds.includes(canId)) {
                    selectCanIds.push(canId)
                }
            } else {
                selectCanIds = selectCanIds.filter(id => id !== canId)
            }

            // if (item.isSelected) {
            // selectCanIds.push(item.general.id)
            // }
        })

        setSelectedCandidateIds([...selectCanIds])
        return selectCanIds
    }

    const nextPage = () => {
        createSelectedCandidateIds()
        console.log('selectedCandidateIds nextPage', selectedCandidateIds)
        if (currentPage < numberPages) {
            let currPage = currentPage + 1
            onSearchCandidates(currPage, searchOrderBy)
            setCurrentPage(currPage)
        }
    };

    const backPage = () => {
        createSelectedCandidateIds()
        console.log('selectedCandidateIds backPage', selectedCandidateIds)
        if (currentPage > 1) {
            let currPage = currentPage - 1
            onSearchCandidates(currPage, searchOrderBy)
            setCurrentPage(currPage)
        }
    };

    // const gotoPage = (targetPage) => {
    //     setCurrentPage(targetPage);
    //     onSearchCandidates(targetPage, searchOrderBy)``
    // };

    const onSelectedAll = () => {
        const canList = candidateList.map(item => {
            item.isSelected = !isSelectedAll
            return item
        })

        setCandidateList([...canList])
        if (!isSelectedAll) {
            setSelectedCandidateIds([...allCandidateIds])
            setSelectedCount(allCandidateIds.length)
        } else {
            setSelectedCandidateIds([])
            setSelectedCount(0)
        }

        setSelectedAll(!isSelectedAll)

        if (onReturnSelectedItems) {
            const sCanIds = createSelectedCandidateIds(!isSelectedAll)
            onReturnSelectedItems(sCanIds)
        }
    };

    const onSelectedItem = (index) => {
        candidateList[index].isSelected = !candidateList[index].isSelected
        if (candidateList[index].isSelected) {
            setSelectedCount(selectedCount + 1)
        } else {
            setSelectedCount(selectedCount - 1)
            setSelectedAll(false)
        }
        setCandidateList([...candidateList])

        if (onReturnSelectedItems) {
            const sCanIds = createSelectedCandidateIds()
            onReturnSelectedItems(sCanIds)
        }
    };

    const onChangeOrderBy = (event) => {
        setSearchOrderBy(event.target.value)
        onSearchCandidates(currentPage, event.target.value)
    }

    const setDisplayPageLink = (totalNumber) => {
        let numberPageCount = Math.ceil(Number(totalNumber) / DEFAULT_PAGE_SIZE)
        setNumberPages(numberPageCount);
        let tempDisplayPageList = []
        if (numberPageCount > MAX_PAGE_LINK_DISPLAY) {
            let rightCount = numberPageCount - currentPage
            if (rightCount > Math.floor(MAX_PAGE_LINK_DISPLAY / 2)) {
                rightCount = Math.floor(MAX_PAGE_LINK_DISPLAY / 2)
            }
            let rightEndIndex = currentPage + rightCount
            let leftCount = MAX_PAGE_LINK_DISPLAY - rightCount - 1
            let leftStartIndex = currentPage - leftCount
            if (leftStartIndex < 0) {
                leftStartIndex = 0
            }
            for (let i = leftStartIndex; i <= rightEndIndex; i++) {
                tempDisplayPageList.push(i);
            }
        } else {
            for (let i = 0; i < numberPageCount; i++) {
                tempDisplayPageList.push(i);
            }
        }

        setDisplayPages(tempDisplayPageList)
    }

    const onSort = async (columnKey) => {
        let sortColumns = { ...sortColumnInfo }
        if (sortColumns[columnKey] && sortColumns[columnKey] === ODER_BY_TYPE.ASC) {
            sortColumns[columnKey] = ODER_BY_TYPE.DESC
        } else {
            sortColumns = {}
            sortColumns[columnKey] = ODER_BY_TYPE.ASC
        }

        setSortColumnInfo(sortColumns)
        // sort candidateList by columnKey
        const sortedList = [...candidateList]
        sortedList.sort((a, b) => {
            // check Order type asc or desc and string or number or work_location
            if (sortColumns[columnKey] === ODER_BY_TYPE.ASC) {
                // if (columnKey === 'workable_location') {
                //     return getWorkableLocation(a).localeCompare(getWorkableLocation(b))
                // }

                if (typeof a[columnKey] === 'string' || !a[columnKey]) {
                    return (a[columnKey] || "0").localeCompare(b[columnKey] || "0")
                }

                // check if columnKey is industry_function
                // if (columnKey === 'industry_function') {
                //     return getIndustryFunctionString(a).localeCompare(getIndustryFunctionString(b))
                // }
                return a[columnKey] - b[columnKey]
            }

            // if (columnKey === 'workable_location') {
            //     return getWorkableLocation(b).localeCompare(getWorkableLocation(a))
            // }

            // check if columnKey is industry_function
            // if (columnKey === 'industry_function') {
            //     return getIndustryFunctionString(b).localeCompare(getIndustryFunctionString(a))
            // }

            if (typeof b[columnKey] === 'string' || !b[columnKey]) {
                return (b[columnKey] || "0").localeCompare(a[columnKey] || "0")
            }

            return b[columnKey] - a[columnKey]
        })

        setCandidateList(sortedList)
    }

    const onClickSortColumn = (column) => {
        onSort(column)
    }

    const classSortingType = (column) => {
        const sortType = sortColumnInfo[column]
        if (sortType) {
            return sortType === ODER_BY_TYPE.DESC ? 'sorting_desc' : 'sorting_asc'
        }

        return ""
    }

    useEffect(() => {
        // default sort by latest sent time desc
        const sortedCandidateList = [...candidates].sort((a, b) => {
            return a.dvtjcuv_info.latest_sent_time.localeCompare(b.dvtjcuv_info.latest_sent_time)
        })
        const cans = sortedCandidateList.map((item, index) => {
            const out = { ...item }
            out.general_id = item.general.id
            out.personal_full_name = item.personal.full_name
            out.general_displayed_company = item.general.displayed_company
            out.general_displayed_title = item.general.displayed_title
            out.location_local_province_email = item.location.local_province_email
            out.category_industry = item.categories.industry
            out.category_function = item.categories.function
            out.location_local_province = item.location.local_province
            out.personal_actual_yob = item.personal.actual_yob
            out.general_blocked = item.general.blocked

            // if item.generanl_id trong selectedCandidateIds thi out.isSelected = true
            out.isSelected = selectedCandidateIds.includes(item.general.id)
            out.dvtjcuv_info = item.dvtjcuv_info
            // out.dvtjcuv_info_employers_name = item.dvtjcuv_info.employers_name
            out.dvtjcuv_info_brief_sent_count = item.dvtjcuv_info.brief_sent_count
            out.process_in_job = item.process_in_job
            out.run_job_candidate_in_send_mails = item.run_job_candidate.in_send_mails
            out.run_job_export_date_time = item.run_job_candidate.export_date_time
            out.run_job_notes = arrayToString(item.run_job_notes)
            out.add_date_time = item.add_date_time
            return out
        })
        setCandidateList([...cans])
    }, [candidates])

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    useEffect(() => {
        setDisplayPageLink(totalCount)
        if (candidateGroups.length === 0) {
            requestCandidateGroups().then(res => {
                if (res.sts_code === ResponseCode.SUCCESS) {
                    setCandidateGroups(res.content.saved_list);
                }
            })
        }
    }, [totalCount]);

    const onShowShowHideCandidatesModal = (isAllCanIds = false) => {
        createSelectedCandidateIds(isAllCanIds)
        setShowShowHideCandidatesModal(true)
    }


    const onShowCreateCandidateGroupModal = (isAllCanIds = false) => {
        createSelectedCandidateIds(isAllCanIds)
        setShowCreateGroupModal(true)
    }

    const onShowAddCandidateIntoGroupModal = (candidateId) => {
        setSelectCandidateId(candidateId)
        setShowAddCandidateIntoGroupModal(true)
    }

    const onShowConfirmRefereeModal = (candidateId) => {
        setSelectCandidateId(candidateId)
        setShowRefereeConfirmModal(true)
    }

    const onClickExportExcel = (exportAll = false) => {
        const candidateIds = exportAll ? allCandidateIds : createSelectedCandidateIds()
        if (candidateIds.length === 0) {
            showMessage("Vui lòng chọn person.")
            return;
        }
        if (onExportExcel) {
            onExportExcel(candidateIds)
        }
    };

    const onClickSendEmailInviteJob = () => {
        const candidateIds = createSelectedCandidateIds()
        if (onSendEmailInviteJob) {
            onSendEmailInviteJob(candidateIds)
        }
    };

    const onClickRemoveSendMailsInThisTime = () => {
        const candidateIds = createSelectedCandidateIds()
        if (updateCandidatesInSendMails) {
            updateCandidatesInSendMails(candidateIds, false)
        }
    };

    const onShowDVTJCUVEmailInviteTempModal = (candidateId) => {
        setSelectCandidateId(candidateId)
        setShowDVTJCUVEmailInviteTempModal(true)
    }

    const onClickRemoveCandidateOutTabs = (tabIds) => {
        const candidateIds = createSelectedCandidateIds()
        if (candidateIds.length === 0) {
            showMessage("Vui lòng chọn person.")
            return;
        }
        let text = `Bạn có chắc chắn muốn xóa (các) Person này khỏi các Tab không"?`;
        if (window.confirm(text) === true) {
            if (removeCandidateOutTabs) {
                removeCandidateOutTabs(tabIds, candidateIds)
            }
        }
    };

    const onClickMoveCandidatesToTab = (currentTabId, nextTabId) => {
        const candidateIds = createSelectedCandidateIds()
        if (moveCandidatesToTab) {
            moveCandidatesToTab(currentTabId, nextTabId, candidateIds)
        }
    };

    const onClickFollowUp = () => {
        const candidateIds = createSelectedCandidateIds()
        if (candidateIds.length === 0) {
            showMessage("Vui lòng chọn person.")
            return;
        }
        if (onEmailFU) {
            onEmailFU(candidateIds)
        }
    };

    const openCandidateDetail = (candidateId) => {
        if (!candidateId) {
            candidateId = candidateList[0].general.id
        }
        localStorage.setItem(LOCAL_STORAGE_ALL_CANDIDATE_IDS, arrayToString(allCandidateIds))
        const win = window.open(`/candidate/detail/${candidateId}`, "_blank");
        win.focus();
        // history.push(`/candidate/detail/${allCandidateIds[candidateIndex]}`,
        //     {allCandidateIds: allCandidateIds, currentCandidateIndex: candidateIndex})

    }

    const onReEmailInviteJob = (candidateIds, internalProcess) => {
        onReMailInviteJob(candidateIds, internalProcess)
    };

    const onBookAndEmailInviteJob = () => {
        const candidateIds = createSelectedCandidateIds()
        onReMailInviteJob(candidateIds, ProcessJobInternalProcess.BookedAndEmailedInviteJob)
    };

    const openRunJobModal = (candidateIds) => {
        if (!candidateIds || candidateIds.length === 0) {
            const canIds = createSelectedCandidateIds()
            setSendingEmailCandidateIds(canIds)
        } else {
            setSendingEmailCandidateIds(candidateIds)
        }

        setShowRunJobModal(true)
    }

    const processRequestStartRunDVTJCUV = (condition) => {
        requestStartRunDVTJCUV(condition).then(res => {
            if (res.sts_code === ResponseCode.SUCCESS) {
                const inviteResult = res.content.email_tab
                const notPermissionCandidateIds = inviteResult.not_permission_email_candidate_ids
                const needCheckingCandidateIds = inviteResult.need_checking_candidate_ids
                const needInputInfoCandidateIds = inviteResult.need_input_info_candidate_ids
                const approveDraftCandidateIds = inviteResult.approve_draft_candidate_ids
                let tabNo = 2;
                if (condition.invite_mode === EmailInviteMode.INVITE_EMAIL_FU) {
                    tabNo = 3;
                }
                else if (condition.invite_mode === EmailInviteMode.INVITE_EMAIL_FU_REC) {
                    tabNo = '3.2';
                }
                showMessage(
                    `
                    Kết quả check:
                    Số UV tab 1: ${approveDraftCandidateIds.length}
                    Số UV tab 2: ${notPermissionCandidateIds.length}
                    Số UV tab 3: ${needCheckingCandidateIds.length}
                    Số UV tab 4: ${needInputInfoCandidateIds.length}`
                )

                setSelectedAll(false)
                onSearchCandidates(currentPage, searchOrderBy)
            } else {
                alertMessage(res.sts_code, true, false);
            }
        })
    }

    const openDVTJCUVEmailInvite = async (candidateIds, isInviteSendJob) => {
        setInviteSendJobMode(!!isInviteSendJob)
        let canIds = createSelectedCandidateIds()
        if (!candidateIds || candidateIds.length === 0) {
            setSendingEmailCandidateIds(canIds)
        } else {
            canIds = candidateIds
            setSendingEmailCandidateIds(canIds)
        }

        if (mode === CandidateListMode.CANDIDATE_LIST) {
            setShowDVTJCUVEmailInviteModal(true)
        } else {
            await processRequestStartRunDVTJCUV({ candidate_ids: canIds })
        }

    }

    const onStartCheckRunDVTJCUVConditions = async (condition = {}) => {
        const canIds = createSelectedCandidateIds()
        condition.candidate_ids = canIds
        setSendingEmailCandidateIds(canIds)
        await processRequestStartRunDVTJCUV(condition)
    }

    const onStartInputEmailInputDVTJCUV = (inviteMode) => {
        const candidateIds = createSelectedCandidateIds()
        onInputEmailInputDVTJCUV(candidateIds, inviteMode)
    }

    const onStartCheckBriefEmailConditions = async (condition = {}) => {
        condition.receiver_ids = createSelectedCandidateIds()
        if (!condition.invite_mode) {
            condition.invite_mode = EmailInviteMode.INVITE_BRIEF_EMAIL
        }
        setSendingEmailCandidateIds(condition.receiver_ids)
        await onSendBriefEmailDVTJCUV(condition)
    }

    // const onStartCheckEmailDNUpdateInfoConditions = async (condition = {}) => {
    //     const canIds = createSelectedCandidateIds()
    //     condition.receiver_ids = canIds
    //     condition.invite_mode = EmailInviteMode.INVITE_EMAIL_DN_UPDATE_INFO
    //     setSendingEmailCandidateIds(canIds)
    //     await onSendBriefEmailDVTJCUV(condition)
    // }

    const openEmbeddedIntoJobModal = (candidateIds) => {
        setShowSelectJobModal(true)
    }

    const openPreviewSendInviteEmails = (candidateIds) => {
        setSendingEmailCandidateIds([...candidateIds])
        setShowDraftMailModal(true)
    }

    const openConfirmEmbeddedIntoJob = (jobId) => {
        onEmbeddedIntoJob(jobId)
        setEmbeddedIntoJob(true)
        setShowSelectJobModal(false)
    }

    const onSaveInputJobPipeline = (candidateId, internalProcess) => {
        saveInputJobPipeline(candidateId, internalProcess)
    }

    const onInputGPEmpDiscussion = (canId) => {
        setSelectCandidateId(canId)
        setShowInputCddGPEmpDiscussionModal(true)
    }
    const onDeleteReceivers = (rectIds) => {
        onDeleteReceiverManuallyRelease(rectIds)
    }

    const showExportTimeColumn = () => {
        return (mode === CandidateListMode.EMAIL_INVITE_JOB && mailInviteJobTab.id === SendEmailInviteJobTabIds.EXPORTED_WAITING_SEND_EMAIL)
            || (mode === CandidateListMode.DVTJCUV && mailInviteJobTab.id === DVTJCUVAcquireCddSendEmailTabIds.EXPORTED_WAITING_SEND_EMAIL)
            || (mode === CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_BRIEF_EMAIL && mailInviteJobTab.id === DVTJCUVSearchCddJobSendEmailBriefUVTabs.EXPORTED_WAITING_SEND_EMAIL_BRIEF_UV_TAB.id)
    }

    const showNotesColumn = () => {
        return (
            mode === CandidateListMode.EMAIL_INVITE_JOB && (
                mailInviteJobTab.id === SendEmailInviteJobTabIds.NOT_PERMISSION_EMAIL
                || mailInviteJobTab.id === SendEmailInviteJobTabIds.NEED_CHECKING
                || mailInviteJobTab.id === SendEmailInviteJobTabIds.NEED_INPUT_INFO
            )
        )
            || (
                mode === CandidateListMode.DVTJCUV && (
                    mailInviteJobTab.id === DVTJCUVAcquireCddSendEmailTabIds.NOT_PERMISSION_EMAIL
                    || mailInviteJobTab.id === DVTJCUVAcquireCddSendEmailTabIds.NEED_CHECKING
                    || mailInviteJobTab.id === DVTJCUVAcquireCddSendEmailTabIds.NEED_INPUT_INFO
                    || mailInviteJobTab.id === DVTJCUVAcquireCddEmailFUTabIds.NOT_PERMISSION_EMAIL
                    || mailInviteJobTab.id === DVTJCUVAcquireCddEmailFUTabIds.NEED_CHECKING
                    || mailInviteJobTab.id === DVTJCUVAcquireCddEmailFUTabIds.NEED_INPUT_INFO
                )
            )
            || (
                mode === CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_BRIEF_EMAIL && (
                    mailInviteJobTab.id === DVTJCUVSearchCddJobSendEmailBriefUVTabs.NOT_PERMISSION_EMAIL_TAB.id
                    || mailInviteJobTab.id === DVTJCUVSearchCddJobSendEmailBriefUVTabs.NEED_CHECKING_TAB.id
                    || mailInviteJobTab.id === DVTJCUVSearchCddJobSendEmailBriefUVTabs.NEED_INPUT_INFO_TAB.id
                    || mailInviteJobTab.id === DVTJCUVSearchCddJobSendEmailBriefUVTabs.WAITING_SEND_BY_WEEK_TAB.id
                    || mailInviteJobTab.id === DVTJCUVSearchCddJobSendEmailBriefUVTabs.WAITING_SEND_BY_MONTH_TAB.id
                )
            ) || mode === CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_EXCLUDE_RECEIVERS
    }

    const onConnectCddEmpReceiverNeedFuSortChange = (event) => {
        const selectValue = event.target.value
        // do sort by value on client side
        // sort by value
        // sort by value of ConnectCddEmpReceiverNeedFuSortOptions
        let sortedCandidateList = [...candidateList]
        if (selectValue === ConnectCddEmpReceiverNeedFuSortOptions.LATEST_SENT_TIME_ASC.value) {
            sortedCandidateList = candidateList.sort((a, b) => {
                return a.dvtjcuv_info.latest_sent_time.localeCompare(b.dvtjcuv_info.latest_sent_time)
            })
        } else if (selectValue === ConnectCddEmpReceiverNeedFuSortOptions.LATEST_SENT_TIME_DESC.value) {
            sortedCandidateList = candidateList.sort((a, b) => {
                return b.dvtjcuv_info.latest_sent_time.localeCompare(a.dvtjcuv_info.latest_sent_time)
            })
        } else if (selectValue === ConnectCddEmpReceiverNeedFuSortOptions.BRIEF_SENT_ASC.value) {
            sortedCandidateList = candidateList.sort((a, b) => {
                return Number(a.dvtjcuv_info.brief_sent_count) - Number(b.dvtjcuv_info.brief_sent_count)
            })
        } else if (selectValue === ConnectCddEmpReceiverNeedFuSortOptions.BRIEF_SENT_DESC.value) {
            sortedCandidateList = candidateList.sort((a, b) => {
                return Number(b.dvtjcuv_info.brief_sent_count) - Number(a.dvtjcuv_info.brief_sent_count)
            })
        }

        setCandidateList([...sortedCandidateList])
    }

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Danh sách Person ({totalCount})</h3>
                {totalCount > 0 && !noPagination &&
                    <h3 className='card-title text-bold ml-3'>Page: {currentPage}/{numberPages}</h3>
                }
                <br />
                {showBtnSelect &&
                    <h4 className='card-title'>Selected: {selectedCount}</h4>
                }
                <div className='card-tools row'>
                    {parentTab?.id === DVTJCUVConnectCddEmpParentTabs.FU_RECEIVERS_TAB.id &&
                        // using compoent sort
                        <div className='mr-2'>
                            <ConnectCddEmpReceiverNeedFuSortComponent
                                // sortBy={sortBy}
                                onChange={onConnectCddEmpReceiverNeedFuSortChange}
                            />
                        </div>
                    }
                    {candidateList && candidateList.length > 0 &&
                        // mode === CandidateListMode.CANDIDATE_LIST &&
                        <>
                            {mode === CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_CHOOSE_RECEIVERS &&
                                <button onClick={() => {
                                    const canIds = createSelectedCandidateIds()
                                    if (canIds.length === 0) {
                                        showMessage("Vui lòng chọn receiver.")
                                        return;
                                    }
                                    onSaveChosenReceivers(canIds)
                                }}
                                    className={'btn btn-primary'} type={'button'}>
                                    Save chosen receivers
                                </button>
                            }

                            {!hideBtnActions && mode !== CandidateListMode.DVTJCUV
                                && mode !== CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_BRIEF_EMAIL &&
                                <div className="btn-group mr-2">
                                    <button type="button" className="btn btn-default">Actions</button>
                                    <button type="button" className="btn btn-default dropdown-toggle dropdown-icon"
                                        data-toggle="dropdown">
                                        <span className="sr-only">Toggle Dropdown</span>
                                    </button>
                                    <div className="dropdown-menu" role="menu">
                                        {mode === CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_EXCLUDE_RECEIVERS &&
                                            <button onClick={() => onDelete(createSelectedCandidateIds())}
                                                className={'dropdown-item'} type={'button'}>Xóa</button>
                                        }
                                        {mode === CandidateListMode.CANDIDATE_LIST &&
                                            <>
                                                <button type={"button"}
                                                    onClick={() => openCandidateDetail()}
                                                    rel="noopener noreferrer" className={'dropdown-item'}>Xem chi tiết tất cả UV
                                                </button>
                                                {userLoginInfo.is_superuser &&
                                                    <button type={"button"}
                                                        onClick={() => onShowShowHideCandidatesModal(true)}
                                                        className={'dropdown-item'}>Show/Hide tất cả UV
                                                    </button>}
                                                {userLoginInfo.is_superuser &&
                                                    <button disabled={selectedCount === 0} type={"button"}
                                                        onClick={() => onShowShowHideCandidatesModal()}
                                                        className={'dropdown-item'}>Show/Hide UV được chọn
                                                    </button>
                                                }
                                                <button type={"button"}
                                                    onClick={() => {
                                                        onShowCreateCandidateGroupModal(true)
                                                    }}
                                                    className={'dropdown-item'}>Lưu tất cả UV
                                                </button>
                                                <button type={"button"}
                                                    disabled={selectedCount === 0}
                                                    onClick={() => {
                                                        onShowCreateCandidateGroupModal()
                                                    }}
                                                    className={'dropdown-item'}>Lưu UV được chọn
                                                </button>
                                                {userLoginInfo.is_superuser &&
                                                    <button type={"button"}
                                                        onClick={() => onClickExportExcel()}
                                                        className={'dropdown-item'}>
                                                        {"Export excel tất cả UV "}
                                                    </button>
                                                }
                                                <button type={"button"}
                                                    disabled={selectedCount === 0}
                                                    onClick={() => openRunJobModal(selectedCandidateIds)}
                                                    className={'dropdown-item'}>Process job
                                                </button>
                                                <button type={"button"}
                                                    // disabled={selectedCount === 0}
                                                    onClick={() => openEmbeddedIntoJobModal(allCandidateIds)}
                                                    className={'dropdown-item'}>Nhúng vào job
                                                </button>
                                                <button type={"button"}
                                                    disabled={selectedCount === 0}
                                                    onClick={() => openDVTJCUVEmailInvite(selectedCandidateIds)}
                                                    className={'dropdown-item'}>Email mời DVTJCUV
                                                </button>
                                                <button type={"button"}
                                                    disabled={selectedCount === 0}
                                                    onClick={() => openDVTJCUVEmailInvite(selectedCandidateIds, true)}
                                                    className={'dropdown-item'}>Gửi Email MỜI GỬI JOB
                                                </button>
                                            </>
                                        }
                                        {mode === CandidateListMode.EMAIL_INVITE_JOB &&
                                            // mailInviteJobTab.id === SendEmailInviteJobTabIds.EXPORTED_WAITING_SEND_EMAIL &&
                                            <>
                                                <button type={"button"}
                                                    disabled={selectedCount === 0}
                                                    onClick={() => onClickSendEmailInviteJob()}
                                                    className={'dropdown-item'}>Tạo Pipeline và chuyển UV khỏi Tab này
                                                </button>
                                                <button type={"button"}
                                                    disabled={selectedCount === 0}
                                                    onClick={() => {
                                                        onClickMoveCandidatesToTab(
                                                            mailInviteJobTab.id,
                                                            SendEmailInviteJobTabIds.APPROVE_DRAFT)
                                                    }}
                                                    className={'dropdown-item'}>Cut Paste back lại Tab 2.1
                                                </button>
                                                <button type={"button"}
                                                    disabled={selectedCount === 0}
                                                    onClick={() => {
                                                        onClickRemoveSendMailsInThisTime()
                                                    }} className={'dropdown-item'}>Loại UV khỏi list gửi email lần này
                                                </button>
                                                <button type={"button"}
                                                    disabled={selectedCount === 0}
                                                    onClick={() => {
                                                        onClickRemoveCandidateOutTabs([mailInviteJobTab.id])
                                                    }}
                                                    className={'dropdown-item'}>Xóa UV khỏi tab này
                                                </button>
                                                <button type={"button"}
                                                    disabled={selectedCount === 0}
                                                    onClick={() => {
                                                        onClickRemoveCandidateOutTabs([
                                                            SendEmailInviteJobTabIds.APPROVE_DRAFT,
                                                            SendEmailInviteJobTabIds.NOT_PERMISSION_EMAIL])
                                                    }} className={'dropdown-item'}>Xóa UV khỏi Tab 1,2
                                                </button>
                                                <button type={"button"}
                                                    disabled={selectedCount === 0}
                                                    onClick={() => {
                                                        onBookAndEmailInviteJob()
                                                    }} className={'dropdown-item'}>Booked + Emailed mời job
                                                </button>
                                            </>
                                        }

                                        {mode === CandidateListMode.EMAIL_INVITE_JOB &&
                                            mailInviteJobTab.id === SendEmailInviteJobTabIds.APPROVE_DRAFT &&
                                            <>
                                                <button type={"button"}
                                                    disabled={selectedCount === 0}
                                                    onClick={() => {
                                                        onClickRemoveSendMailsInThisTime()
                                                    }} className={'dropdown-item'}>Loại UV khỏi list gửi email lần này
                                                </button>
                                            </>
                                        }
                                    </div>
                                </div>
                            }
                            {(mode === CandidateListMode.DVTJCUV
                                || mode === CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_BRIEF_EMAIL) &&
                                <div className='float-right'>
                                    <DVTJCUVCandidateActions
                                        mode={mode}
                                        selectedCandidateIds={selectedCandidateIds}
                                        parentTab={parentTab}
                                        subTab={subTab}
                                        onDraftPreview={onDraftPreview}
                                        onExportExcel={onClickExportExcel}
                                        onEmailFU={onClickFollowUp}
                                        onShowDVTJCUVEmailInviteTemp={onShowDVTJCUVEmailInviteTempModal}
                                        onClickMoveCandidatesToTab={onClickMoveCandidatesToTab}
                                        onSendEmailDVTJCUV={onStartCheckRunDVTJCUVConditions}
                                        onSendBriefEmailDVTJCUV={onStartCheckBriefEmailConditions}
                                        onStartCheckingRunDVTJCUVConditions={onStartCheckRunDVTJCUVConditions}
                                        onInputEmailInputDVTJCUV={onStartInputEmailInputDVTJCUV}
                                        onRemoveSendMailThisTime={onRemoveSendMailThisTime}
                                        onRemoveCandidateOutTabs={onClickRemoveCandidateOutTabs}
                                    />
                                </div>
                            }

                            {userLoginInfo.is_superuser && isExporting &&
                                <button className='btn btn-success mr-2' type={'button'}
                                    disabled={"disabled"}>Exporting...
                                </button>
                            }
                        </>
                    }

                    {(mode === CandidateListMode.CANDIDATE_LIST
                        || parentTab?.id === DVTJCUVConnectCddEmpParentTabs.CALL_CHAT_DN_REC_UPD_INF.id
                        || parentTab?.id === DVTJCUVWorkWithRecParentTabs.CALL_CHAT_DN_REC_UPDATE_INFO_TAB.id
                    ) &&
                        <select className='ml-2'
                            style={{
                                padding: '0.375rem 0.75rem', backgroundColor: '#fff', border: '1px solid #ced4da',
                                borderRadius: '0.25rem',
                                boxShadow: 'inset 0 0 0 transparent',
                                transition: 'border-color .15s ease-in-out,box-shadow .15s ease-in-out'
                            }}
                            name={'order_by'}
                            value={searchOrderBy}
                            onChange={event => onChangeOrderBy(event)}>
                            {mode === CandidateListMode.CANDIDATE_LIST ?
                                <>
                                    <option value='1'>Nhập mới hơn trước</option>
                                    <option value='2'>Nhập cũ hơn trước</option>
                                </>
                                :
                                <>
                                    <option value='1'>Note time mới hơn trước</option>
                                    <option value='2'>Note time cũ hơn trước</option>
                                </>
                            }
                        </select>
                    }

                    {numberPages > 1 && !noPagination &&
                        <ul className='pagination pagination-sm float-right mt-2 ml-5'>
                            <li className='page-item'>
                                <button className='page-link' type={'button'}
                                    onClick={() => backPage()}>&laquo;</button>
                            </li>
                            {/*{displayPages.map((page) => {*/}
                            {/*    if (currentPage === (page + 1)) {*/}
                            {/*        return <li className='page-item' key={`top-page-link-${page}`}>*/}
                            {/*            <button className='page-link bg-blue' type={'button'}*/}
                            {/*                    onClick={() => gotoPage(page + 1)}>{page + 1}</button>*/}
                            {/*        </li>*/}
                            {/*    }*/}
                            {/*    return <li className='page-item' key={`page_${page}`}>*/}
                            {/*        <button className='page-link' type={'button'}*/}
                            {/*                onClick={() => gotoPage(page + 1)}>{page + 1}</button>*/}
                            {/*    </li>*/}
                            {/*})}*/}
                            <li className='page-item'>
                                <button className='page-link' type={'button'}
                                    onClick={() => nextPage()}>&raquo;</button>
                            </li>
                        </ul>
                    }
                </div>
            </div>
            <div className='card-body table-responsive p-0'>
                <table
                    className='table table-hover dataTable table-bordered text-nowrap text-center'
                // style={{maxHeight: '80vh', overflow: 'scroll'}}
                >
                    <thead>
                        <tr>
                            {showBtnSelect &&
                                <th className={"pl-0"}>
                                    <input type="checkbox"
                                        style={{ width: 20, height: 20 }}
                                        checked={isSelectedAll}
                                        onChange={event => onSelectedAll(event)}
                                    />
                                </th>
                            }
                            <th>No.</th>
                            <th
                                className={`sorting ${classSortingType('general_id')}`}
                                onClick={() => onClickSortColumn('general_id')}
                            >
                                {(parentTab && (parentTab?.id === DVTJCUVSearchCddJobParentTabs.SEND_EMAIL_BRIEF_UV_TAB.id
                                    || parentTab?.id === DVTJCUVConnectCddSendEmailReceiverUpdateInfoTabs.SEND_EMAIL_TAB.id
                                    || parentTab?.id === DVTJCUVWorkWithRecParentTabs.SEND_EMAIL_INVITE_JOB_TAB.id
                                    || parentTab?.id === DVTJCUVConnectCddEmpParentTabs.SEND_EMAIL_RECEIVER_UPDATE_INFO_TAB.id
                                    || parentTab?.id === DVTJCUVConnectCddEmpParentTabs.FU_RECEIVERS_TAB.id
                                    || parentTab?.id === DVTJCUVConnectCddEmpParentTabs.CALL_CHAT_DN_REC_UPD_INF.id
                                    || parentTab?.id === DVTJCUVWorkWithRecParentTabs.CALL_CHAT_DN_REC_UPDATE_INFO_TAB.id
                                ) || mode === CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_EXCLUDE_RECEIVERS
                                    || mode === CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_CHOOSE_RECEIVERS
                                )
                                    ? 'Cdd Receiver ID' : 'Person ID'}
                            </th>
                            <th
                                className={`sorting ${classSortingType('personal_full_name')}`}
                                onClick={() => onClickSortColumn('personal_full_name')}
                            >Họ & tên</th>
                            <th className={`sorting ${classSortingType('general_displayed_company')}`}
                                onClick={() => onClickSortColumn('general_displayed_company')}
                            >Displayed Company</th>
                            <th
                                className={`sorting ${classSortingType('general_displayed_title')}`}
                                onClick={() => onClickSortColumn('general_displayed_title')}
                            >Displayed Title</th>
                            {(parentTab?.id === DVTJCUVConnectCddEmpParentTabs.FU_RECEIVERS_TAB.id ||
                                parentTab?.id === DVTJCUVConnectCddEmpParentTabs.NEW_CDDS_TAB.id ||
                                parentTab?.id === DVTJCUVConnectCddEmpParentTabs.CALL_CHAT_DN_REC_UPD_INF.id ||
                                parentTab?.id === DVTJCUVWorkWithRecParentTabs.CALL_CHAT_DN_REC_UPDATE_INFO_TAB.id ||
                                (parentTab?.id === DVTJCUVConnectCddEmpParentTabs.SEND_EMAIL_RECEIVER_UPDATE_INFO_TAB.id
                                    && subTab?.id === DVTJCUVConnectCddSendEmailReceiverUpdateInfoTabs.RECEIVER_LIST_TAB.id
                                ) || parentTab?.id === DVTJCUVCddOpenAndNotSddvParentTabs.NEW_CDDS_TAB.id
                                || mode === CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_RECEIVER_MANUALLY_RELEASE
                                || mode === CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_RECEIVER_SENT
                                || mode === CandidateListMode.DVTJCUV_SEARCH_CDD
                            ) &&
                                <>
                                    <th
                                        className={`sorting ${classSortingType('location_local_province_email')}`}
                                        onClick={() => onClickSortColumn('location_local_province_email')}
                                    >Location Tỉnh (Email)</th>
                                </>
                            }
                            {(mode === CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_EXCLUDE_RECEIVERS ||
                                mode === CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_RECEIVER_SENT ||
                                parentTab?.id === DVTJCUVConnectCddEmpParentTabs.FU_RECEIVERS_TAB.id ||
                                parentTab?.id === DVTJCUVConnectCddEmpParentTabs.CALL_CHAT_DN_REC_UPD_INF.id ||
                                parentTab?.id === DVTJCUVWorkWithRecParentTabs.CALL_CHAT_DN_REC_UPDATE_INFO_TAB.id ||
                                parentTab?.id === DVTJCUVConnectCddEmpParentTabs.SEND_EMAIL_RECEIVER_UPDATE_INFO_TAB.id
                            ) &&
                                <>
                                    <th
                                        className={`sorting ${classSortingType('category_industry')}`}
                                        onClick={() => onClickSortColumn('category_industry')}
                                    >Industry</th>
                                    <th
                                        className={`sorting ${classSortingType('category_function')}`}
                                        onClick={() => onClickSortColumn('category_function')}
                                    >Function</th>
                                </>
                            }
                            {parentTab?.id !== DVTJCUVConnectCddEmpParentTabs.FU_RECEIVERS_TAB.id &&
                                parentTab?.id !== DVTJCUVConnectCddEmpParentTabs.NEW_CDDS_TAB.id &&
                                parentTab?.id !== DVTJCUVConnectCddEmpParentTabs.CALL_CHAT_DN_REC_UPD_INF.id &&
                                parentTab?.id !== DVTJCUVWorkWithRecParentTabs.CALL_CHAT_DN_REC_UPDATE_INFO_TAB.id &&
                                (parentTab?.id !== DVTJCUVConnectCddEmpParentTabs.SEND_EMAIL_RECEIVER_UPDATE_INFO_TAB.id
                                    && subTab?.id !== DVTJCUVConnectCddSendEmailReceiverUpdateInfoTabs.RECEIVER_LIST_TAB.id
                                ) || parentTab?.id === DVTJCUVCddOpenAndNotSddvParentTabs.NEW_CDDS_TAB.id
                                &&
                                <>
                                    <th
                                        className={`sorting ${classSortingType('location_local_province')}`}
                                        onClick={() => onClickSortColumn('location_local_province')}
                                    >Location (Tỉnh)</th>
                                    <th
                                        className={`sorting ${classSortingType('personal_actual_yob')}`}
                                        onClick={() => onClickSortColumn('personal_actual_yob')}
                                    >YOB</th>
                                    <th
                                        className={`sorting ${classSortingType('general_blocked')}`}
                                        onClick={() => onClickSortColumn('general_blocked')}
                                    >Block UV</th>
                                </>
                            }
                            {(parentTab?.id === DVTJCUVConnectCddEmpParentTabs.FU_RECEIVERS_TAB.id
                                || parentTab?.id === DVTJCUVConnectCddEmpParentTabs.CALL_CHAT_DN_REC_UPD_INF.id
                                || parentTab?.id === DVTJCUVWorkWithRecParentTabs.CALL_CHAT_DN_REC_UPDATE_INFO_TAB.id) &&
                                <>
                                    <th
                                        className={`sorting ${classSortingType('dvtjcuv_info_employers_id')}`}
                                        onClick={() => onClickSortColumn('dvtjcuv_info_employers_id')}
                                    >Employer ID</th>
                                    <th
                                        className={`sorting ${classSortingType('dvtjcuv_info_employers_name')}`}
                                        onClick={() => onClickSortColumn('dvtjcuv_info_employers_name')}
                                    >Employer Name</th>
                                    <th
                                        className={`sorting ${classSortingType('dvtjcuv_info_brief_sent_count')}`}
                                        onClick={() => onClickSortColumn('dvtjcuv_info_brief_sent_count')}
                                    >Số Brief Sent</th>
                                </>
                            }
                            {isEmbeddedIntoJob &&
                                <th
                                    className={`sorting ${classSortingType('process_in_job')}`}
                                    onClick={() => onClickSortColumn('process_in_job')}
                                >Process in job</th>
                            }
                            {/*<th>Chế độ tìm job hiện tại</th>*/}
                            {/*<th>Note quan trọng</th>*/}
                            {/*<th>Latest Company Latest Title</th>*/}
                            {/*<th>Chứng chỉ đặc biệt</th>*/}
                            {/*<th>Engagement Status</th>*/}
                            {/*<th>Số ĐT</th>*/}
                            {mode === CandidateListMode.EMAIL_INVITE_JOB &&
                                (mailInviteJobTab.id === SendEmailInviteJobTabIds.EXPORTED_WAITING_SEND_EMAIL ||
                                    mailInviteJobTab.id === SendEmailInviteJobTabIds.APPROVE_DRAFT) &&
                                <th
                                    className={`sorting ${classSortingType('run_job_candidate_in_send_mails')}`}
                                    onClick={() => onClickSortColumn('run_job_candidate_in_send_mails')}
                                >Trong list gửi email lần này</th>
                            }
                            {showExportTimeColumn() && <th
                                className={`sorting ${classSortingType('run_job_export_date_time')}`}
                                onClick={() => onClickSortColumn('run_job_export_date_time')}
                            >Export Time</th>}
                            {showNotesColumn() &&
                                <th
                                    className={`sorting ${classSortingType('run_job_notes')}`}
                                    onClick={() => onClickSortColumn('run_job_notes')}
                                >Notes</th>
                            }
                            {mode === CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_EXCLUDE_RECEIVERS &&
                                <>
                                    {/*<th>Lần SD dịch vụ</th>*/}
                                    <th
                                        className={`sorting ${classSortingType('add_date_time')}`}
                                        onClick={() => onClickSortColumn('add_date_time')}
                                    >Add time</th>
                                </>
                            }
                            <th>Hành động</th>
                        </tr>
                    </thead>
                    <tbody>
                        {candidateList && candidateList.length > 0 && candidateList.map((candidate, index) => (
                            <tr key={`candidate_${index}`} className={`${candidate.hightlight_class}`}>
                                {showBtnSelect &&
                                    <td style={{ paddingLeft: '.75rem' }}>
                                        <input type="checkbox"
                                            style={{ width: 20, height: 20 }}
                                            // value={!!searchConditions.only_user_input}
                                            checked={candidate.isSelected}
                                            onChange={() => onSelectedItem(index)}
                                        />
                                    </td>
                                }
                                <td>{(currentPage - 1) * DEFAULT_PAGE_SIZE + index + 1}</td>
                                <td>
                                    <a href="javascript:void(0)"
                                        className={`${candidate.hightlight_class}`}
                                        onClick={() => openCandidateDetail(candidate.general_id)}>
                                        {candidate.general_id}
                                    </a>
                                </td>
                                <td>
                                    <a href="javascript:void(0)"
                                        className={`${candidate.hightlight_class}`}
                                        onClick={() => openCandidateDetail(candidate.general_id)}>
                                        <b>{capitalizeName(candidate.personal?.full_name)}</b>
                                    </a>
                                </td>
                                <td>{candidate.general_displayed_company}</td>
                                <td>{candidate.general_displayed_title}</td>

                                {(parentTab?.id === DVTJCUVConnectCddEmpParentTabs.FU_RECEIVERS_TAB.id ||
                                    parentTab?.id === DVTJCUVConnectCddEmpParentTabs.NEW_CDDS_TAB.id ||
                                    parentTab?.id === DVTJCUVConnectCddEmpParentTabs.CALL_CHAT_DN_REC_UPD_INF.id ||
                                    parentTab?.id === DVTJCUVWorkWithRecParentTabs.CALL_CHAT_DN_REC_UPDATE_INFO_TAB.id ||
                                    (parentTab?.id === DVTJCUVConnectCddEmpParentTabs.SEND_EMAIL_RECEIVER_UPDATE_INFO_TAB.id
                                        && subTab?.id === DVTJCUVConnectCddSendEmailReceiverUpdateInfoTabs.RECEIVER_LIST_TAB.id
                                    ) || parentTab?.id === DVTJCUVCddOpenAndNotSddvParentTabs.NEW_CDDS_TAB.id
                                    || mode === CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_RECEIVER_MANUALLY_RELEASE
                                    || mode === CandidateListMode.DVTJCUV_SEARCH_CDD
                                    || mode === CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_RECEIVER_SENT)
                                    &&
                                    <>
                                        <td>{candidate.location_local_province_email}</td>
                                    </>
                                }
                                {(mode === CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_EXCLUDE_RECEIVERS
                                    || mode === CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_RECEIVER_SENT
                                    || parentTab?.id === DVTJCUVConnectCddEmpParentTabs.FU_RECEIVERS_TAB.id
                                    || parentTab?.id === DVTJCUVConnectCddEmpParentTabs.CALL_CHAT_DN_REC_UPD_INF.id
                                    || parentTab?.id === DVTJCUVWorkWithRecParentTabs.CALL_CHAT_DN_REC_UPDATE_INFO_TAB.id
                                    || parentTab?.id === DVTJCUVConnectCddEmpParentTabs.SEND_EMAIL_RECEIVER_UPDATE_INFO_TAB.id
                                ) &&
                                    <>
                                        <td> {candidate.category_industry}</td>
                                        <td>{candidate.category_function}</td>
                                    </>
                                }
                                {parentTab?.id !== DVTJCUVConnectCddEmpParentTabs.FU_RECEIVERS_TAB.id &&
                                    parentTab?.id !== DVTJCUVConnectCddEmpParentTabs.NEW_CDDS_TAB.id &&
                                    parentTab?.id !== DVTJCUVConnectCddEmpParentTabs.CALL_CHAT_DN_REC_UPD_INF.id &&
                                    parentTab?.id !== DVTJCUVWorkWithRecParentTabs.CALL_CHAT_DN_REC_UPDATE_INFO_TAB.id &&
                                    (parentTab?.id !== DVTJCUVConnectCddEmpParentTabs.SEND_EMAIL_RECEIVER_UPDATE_INFO_TAB.id
                                        && subTab?.id !== DVTJCUVConnectCddSendEmailReceiverUpdateInfoTabs.RECEIVER_LIST_TAB.id
                                    ) || parentTab?.id === DVTJCUVCddOpenAndNotSddvParentTabs.NEW_CDDS_TAB.id
                                    &&
                                    <>
                                        <td>{candidate.location_local_province}</td>
                                        <td>{candidate.personal_actual_yob}</td>
                                        <td>{candidate.general_blocked ?
                                            <span className='badge badge-pill badge-danger'>Blocked</span>
                                            : <span className='badge badge-pill badge-success'>Active</span>}
                                        </td>
                                    </>
                                }
                                {(parentTab?.id === DVTJCUVConnectCddEmpParentTabs.FU_RECEIVERS_TAB.id
                                    || parentTab?.id === DVTJCUVConnectCddEmpParentTabs.CALL_CHAT_DN_REC_UPD_INF.id
                                    || parentTab?.id === DVTJCUVWorkWithRecParentTabs.CALL_CHAT_DN_REC_UPDATE_INFO_TAB.id
                                ) &&
                                    <>
                                        <td> {candidate.dvtjcuv_info?.employers?.map(item => {
                                            return <><a href={`/employer/edit/${item.id}`} target="_blank" rel="noopener noreferrer">{item.id}</a><br /></>
                                        })}</td>
                                        <td> {candidate.dvtjcuv_info?.employers?.map(item => {
                                            return <><a href={`/employer/edit/${item.id}`} target="_blank" rel="noopener noreferrer">{item.name}</a><br /></>
                                        })}</td>
                                        <td> {candidate.dvtjcuv_info?.brief_sent_count}</td>
                                    </>
                                }
                                {isEmbeddedIntoJob &&
                                    <td>{candidate.process_in_job ? "Highest Process" : "No"}</td>
                                }
                                {mode === CandidateListMode.EMAIL_INVITE_JOB &&
                                    (mailInviteJobTab.id === SendEmailInviteJobTabIds.EXPORTED_WAITING_SEND_EMAIL ||
                                        mailInviteJobTab.id === SendEmailInviteJobTabIds.APPROVE_DRAFT) &&
                                    <td>{candidate.run_job_candidate_in_send_mails ? "YES" : "NO"}</td>
                                }
                                {showExportTimeColumn() && <td>{candidate.run_job_export_date_time}</td>}

                                {showNotesColumn() &&
                                    <td style={{ textAlign: 'left' }}>{stringToArray(candidate.run_job_notes).map(note => (
                                        <div>{note}</div>
                                    ))}</td>
                                }

                                {mode === CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_EXCLUDE_RECEIVERS &&
                                    <>
                                        {/*<td>{candidate.max_service_use_times}</td>*/}
                                        <td>{candidate.add_date_time}</td>
                                    </>
                                }
                                <td>
                                    {(mode !== CandidateListMode.DVTJCUV
                                        && mode !== CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_BRIEF_EMAIL
                                        && mode !== CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_EXCLUDE_RECEIVERS
                                        && mode !== CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_EXCLUDE_EMPLOYERS
                                        && mode !== CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_SOURCE_MORE_RECEIVER
                                        && mode !== CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_RECEIVER_SENT
                                        && mode !== CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_RECEIVER_MANUALLY_RELEASE
                                    ) &&
                                        <div className="btn-group">
                                            <button type="button" className="btn btn-default">Action</button>
                                            <button type="button" className="btn btn-default dropdown-toggle dropdown-icon"
                                                data-toggle="dropdown">
                                                <span className="sr-only">Toggle Dropdown</span>
                                            </button>

                                            {mode === CandidateListMode.CANDIDATE_LIST &&
                                                <div className="dropdown-menu" role="menu">
                                                    <button type={"button"}
                                                        onClick={() => openCandidateDetail(candidate.general.id)}
                                                        rel="noopener noreferrer" className={'dropdown-item'}>Xem chi
                                                        tiết
                                                    </button>
                                                    <a href="#"
                                                        onClick={() => onShowConfirmRefereeModal(candidate.general.id)}
                                                        className={'dropdown-item'}>Nhập Referee</a>
                                                    <a href="#"
                                                        onClick={() => onShowAddCandidateIntoGroupModal(candidate.general.id)}
                                                        className={'dropdown-item'}>Lưu vào Saved List</a>
                                                    <a href={`/candidate/input-info/${candidate.general.id}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer" className={'dropdown-item'}>Thông tin
                                                        NL</a>
                                                    {canDelete &&
                                                        <a href="#" onClick={() => {
                                                            let text = "Bạn chắc chắn muốn xóa CV?";
                                                            if (window.confirm("Bạn chắc chắn muốn xóa Person này khỏi Saved List?") === true) {
                                                                onDelete(candidate.general.id)
                                                            }
                                                        }}
                                                            className={'dropdown-item'}>Xóa khỏi Saved List</a>
                                                    }

                                                    <button type={"button"}
                                                        onClick={() => openRunJobModal([candidate.general.id])}
                                                        rel="noopener noreferrer" className={'dropdown-item'}>Process
                                                        job
                                                    </button>

                                                    <button type={"button"}
                                                        onClick={() => openDVTJCUVEmailInvite([candidate.general.id])}
                                                        rel="noopener noreferrer" className={'dropdown-item'}>Email mời
                                                        DVTJCUV
                                                    </button>
                                                    <button type={"button"}
                                                        onClick={() => openDVTJCUVEmailInvite([candidate.general.id], true)}
                                                        rel="noopener noreferrer" className={'dropdown-item'}>Gửi Email MỜI GỬI JOB
                                                    </button>
                                                </div>
                                            }

                                            {mode === CandidateListMode.EMAIL_INVITE_JOB &&
                                                <div className="dropdown-menu" role="menu">
                                                    <button type={"button"}
                                                        onClick={() => onReEmailInviteJob([candidate.general.id])}
                                                        rel="noopener noreferrer" className={'dropdown-item'}>Email mời
                                                        job
                                                    </button>

                                                    {mailInviteJobTab.id === SendEmailInviteJobTabIds.APPROVE_DRAFT &&
                                                        <>
                                                            <button type={"button"}
                                                                onClick={() => openPreviewSendInviteEmails([candidate.general.id])}
                                                                className={'dropdown-item'}>Draft Preview
                                                            </button>
                                                            <button type={"button"}
                                                                onClick={() => {
                                                                }} className={'dropdown-item'}>Send Email
                                                            </button>
                                                        </>
                                                    }

                                                    {mailInviteJobTab.id === SendEmailInviteJobTabIds.NOT_PERMISSION_EMAIL &&
                                                        <button type={"button"}
                                                            onClick={() => {
                                                                onSaveInputJobPipeline(candidate.general.id, ProcessJobInternalProcess.WaitingInLine)
                                                            }} className={'dropdown-item'}>Xếp hàng chờ
                                                        </button>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    }
                                    {mode === CandidateListMode.DVTJCUV &&
                                        <div className="btn-group">
                                            <button type="button" className="btn btn-default">Action</button>
                                            <button type="button" className="btn btn-default dropdown-toggle dropdown-icon"
                                                data-toggle="dropdown">
                                                <span className="sr-only">Toggle Dropdown</span>
                                            </button>
                                            <div className="dropdown-menu" role="menu">
                                                {(parentTab?.id === DVTJCUVAcquireCddParentTabIds.EMAIL_TAB
                                                    || parentTab?.id === DVTJCUVAcquireCddParentTabIds.FU_EMAIL_TAB
                                                    || parentTab?.id === DVTJCUVWorkWithRecSendEmailInviteJobTabs.SEND_EMAIL_INVITE_JOB_TAB.id
                                                    || parentTab?.id === DVTJCUVWorkWithRecSendEmailInviteJobTabs.SEND_EMAIL_INVITE_JOB_FU_TAB.id
                                                ) &&
                                                    <button
                                                        type={'button'}
                                                        onClick={() => onShowDVTJCUVEmailInviteTempModal(candidate.general.id)}
                                                        rel="noopener noreferrer"
                                                        className={'dropdown-item'}
                                                    >
                                                        Xem TT lưu tạm
                                                    </button>
                                                }
                                                {parentTab?.id === DVTJCUVConnectCddEmpParentTabs.FU_RECEIVERS_TAB.id &&
                                                    <>
                                                        <a
                                                            href={`/cdd-need-fu/list?cdd_rec_id=${candidate.general.id}`}
                                                            target="_blank"
                                                            className={'dropdown-item'}
                                                            rel="noopener noreferrer"
                                                        >
                                                            List cdd cần FU
                                                        </a>
                                                    </>
                                                }
                                                {(parentTab?.id === DVTJCUVConnectCddEmpParentTabs.FU_RECEIVERS_TAB.id ||
                                                    parentTab?.id === DVTJCUVConnectCddEmpParentTabs.CALL_CHAT_DN_REC_UPD_INF.id
                                                    || parentTab?.id === DVTJCUVWorkWithRecParentTabs.CALL_CHAT_DN_REC_UPDATE_INFO_TAB.id) &&
                                                    <>
                                                        <button
                                                            type={'button'}
                                                            onClick={() => onInputGPEmpDiscussion(candidate.general.id)}
                                                            className={'dropdown-item'}
                                                        >
                                                            {'Note Discussion w Rec'}
                                                        </button>
                                                    </>
                                                }
                                                {parentTab?.id === DVTJCUVConnectCddEmpParentTabs.NEW_CDDS_TAB.id || parentTab?.id === DVTJCUVCddOpenAndNotSddvParentTabs.NEW_CDDS_TAB.id &&
                                                    <>
                                                        <button type='button'
                                                            className='dropdown-item'
                                                            onClick={() => {
                                                                setSelectCandidateId(candidate.general.id)
                                                                setIsShowSearchCddJobModal(true)
                                                            }}
                                                        >
                                                            Set list Receivers
                                                        </button>
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    }

                                    {mode === CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_RECEIVER_SENT &&
                                        <div className="btn-group">
                                            <button type="button" className="btn btn-default">Action</button>
                                            <button type="button" className="btn btn-default dropdown-toggle dropdown-icon"
                                                data-toggle="dropdown">
                                                <span className="sr-only">Toggle Dropdown</span>
                                            </button>
                                            <div className="dropdown-menu" role="menu">
                                                <>
                                                    <button
                                                        type={'button'}
                                                        onClick={() => onInputGPEmpDiscussion(candidate.general.id)}
                                                        className={'dropdown-item'}
                                                    >
                                                        {'Nhập Cdd-GP-Emp Discussion'}
                                                    </button>
                                                </>
                                            </div>
                                        </div>
                                    }

                                    {mode === CandidateListMode.DVTJCUV_SEARCH_CDD_JOB_RECEIVER_MANUALLY_RELEASE &&
                                        <div className="btn-group">
                                            <button type="button" className="btn btn-default">Action</button>
                                            <button type="button" className="btn btn-default dropdown-toggle dropdown-icon"
                                                data-toggle="dropdown">
                                                <span className="sr-only">Toggle Dropdown</span>
                                            </button>
                                            <div className="dropdown-menu" role="menu">
                                                <>
                                                    <button
                                                        type={'button'} onClick={() => onDeleteReceivers([candidate.general.id])}
                                                        className={'dropdown-item mr-2'}>
                                                        Xoá
                                                    </button>
                                                </>
                                            </div>
                                        </div>

                                    }
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className='card-footer'>
                <div className='card-tools'>
                    {numberPages > 1 && !noPagination &&
                        <ul className='pagination pagination-sm float-right'>
                            <li className='page-item'>
                                <button className='page-link' type={'button'}
                                    onClick={() => backPage()}>&laquo;</button>
                            </li>
                            {/*{displayPages.map((page) => {*/}
                            {/*    if (currentPage === (page + 1)) {*/}
                            {/*        return <li className='page-item' key={`footer-page-link-${page}`}>*/}
                            {/*            <button className='page-link bg-blue' type={'button'}*/}
                            {/*                    onClick={() => gotoPage(page + 1)}>{page + 1}</button>*/}
                            {/*        </li>*/}
                            {/*    }*/}
                            {/*    return <li className='page-item' key={`page_${page}`}>*/}
                            {/*        <button className='page-link' type={'button'}*/}
                            {/*                onClick={() => gotoPage(page + 1)}>{page + 1}</button>*/}
                            {/*    </li>*/}
                            {/*})}*/}
                            <li className='page-item'>
                                <button className='page-link' type={'button'}
                                    onClick={() => nextPage()}>&raquo;</button>
                            </li>
                        </ul>
                    }
                </div>
            </div>

            <CreateCandidateGroupModal isShow={showCreateGroupModal}
                candidates={candidateList}
                allCandidateIds={selectedCandidateIds}
                onClose={(isSuccess) => {
                    setShowCreateGroupModal(false)
                    if (isSuccess === true) {
                        toast.success(`Tạo saved list mới thành công.`);
                    } else if (isSuccess === false) {
                        toast.error(`Tạo saved list mới thất bại.`);
                    }
                }} />
            <AddCandidateIntoGroupModal isShow={showAddCandidateIntoGroupModal}
                candidateId={selectCandidateId}
                groups={candidateGroups}
                onClose={(isSuccess, message) => {
                    setShowAddCandidateIntoGroupModal(false)
                    if (isSuccess === true) {
                        toast.success(message);
                    } else if (isSuccess === false) {
                        toast.error(message);
                    }
                }} />
            <RefereeConfirmModal isShow={showRefereeConfirmModal}
                refererId={selectCandidateId}
                onClose={() => {
                    setShowRefereeConfirmModal(false)
                }}
            />
            <ShowHideCandidatesModal isShow={showShowHideCandidatesModal}
                candidateIds={selectedCandidateIds}
                onClose={(isSuccess) => {
                    setShowShowHideCandidatesModal(false)
                    if (isSuccess === true) {
                        toast.success(`Xử lý thành công.`);
                    } else if (isSuccess === false) {
                        toast.error(`Xử lý thất bại.`);
                    }
                }} />
            {showRunJobModal &&
                <RunJobMainModal candidateIds={sendingEmailCandidateIds}
                    onClose={() => setShowRunJobModal(false)}
                    isShow={showRunJobModal} />
            }
            {showDraftInviteMailModal &&
                <DraftPreviewModal candidateIds={sendingEmailCandidateIds}
                    onClose={() => setShowDraftMailModal(false)}
                    isShow={showDraftInviteMailModal} />
            }

            {showSelectJobModal &&
                <SelectJobModal
                    onConfirm={(jobId) => { openConfirmEmbeddedIntoJob(jobId) }}
                    onClose={() => setShowSelectJobModal(false)}
                    isShow={showSelectJobModal} />
            }
            {showDVTJCUVEmailInviteModal &&
                <DVTJCUVEmailInviteModal candidateIds={sendingEmailCandidateIds}
                    onClose={() => setShowDVTJCUVEmailInviteModal(false)}
                    isShow={showDVTJCUVEmailInviteModal}
                    mode={isInviteSendJobMode ? EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB : EmailInviteMode.INVITE_EMAIL}
                    isInviteSendJobMode={isInviteSendJobMode}
                />
            }
            {showDVTJCUVEmailInviteTempModal &&
                <DVTJCUVEmailInviteTempInfoModal
                    parentTab={parentTab}
                    subTab={subTab}
                    candidateId={selectCandidateId}
                    onClose={() => setShowDVTJCUVEmailInviteTempModal(false)}
                    isShow={showDVTJCUVEmailInviteTempModal} />
            }
            {showInputCddGPEmpDiscussionModal && selectCandidateId &&
                <InputCddGPEmpDiscussionModal
                    pipelineInfo={{ cdd_receiver_id: selectCandidateId, cdd_id: cddId }}
                    onClose={(success) => {
                        if (success) {
                            showMessage("Đã lưu Cdd-GP-Emp Discussion thành công.", false, true, false, true);
                        }
                        setShowInputCddGPEmpDiscussionModal(false);
                    }}
                    isShow={showInputCddGPEmpDiscussionModal} />
            }

            {isShowSearchCddJobModal &&
                <DVTJCUVSearchCddJobModal
                    cddId={selectCandidateId}
                    isShow={isShowSearchCddJobModal}
                    onClose={() => setIsShowSearchCddJobModal(false)}
                />
            }

        </div>
    );
};

export default CandidateListTable;
